import { SvgSymbol } from '#PRIVATE_SvgShapes';
import { ImageMarker } from './LegendImageMarker';
import { Property } from 'csstype';
import { styles } from '#PRIVATE_BaseLegend/themes/LegendStyles.css';
import { SymbolProps } from '#utils/UNSAFE_visTypes/legend';

type LegendSymbolProps = {
  isHidden?: boolean;
  lineLength?: number;
  width?: Property.Width;
  height?: Property.Height;
  borderColor?: Property.Color;
} & SymbolProps;

export const LegendSymbol = ({
  // The default color is not in the redwood pallete.
  // TODO: replace default legend color with UX approved pallete color when available.
  markerColor = '#a6acb1',
  lineColor = '#a6acb1',
  markerShape = 'square',
  isHidden = false,
  lineStyle = 'none',
  ...props
}: LegendSymbolProps) => {
  const { legendSymbolBaseStyle } = styles;
  const dimensionsNotSet = props.width == null && props.height == null;
  const setAspectRatioNone =
    !dimensionsNotSet && (markerShape === 'rectangle' || markerShape === 'ellipse');
  const defaultLineWidth = lineStyle != 'none' && markerShape != 'none' ? 2 : 3;
  return (
    <div className={legendSymbolBaseStyle} style={{ width: props.width, height: props.height }}>
      {props.source ? (
        <ImageMarker source={props.source} />
      ) : (
        <SvgSymbol
          setAspectRatioNone={setAspectRatioNone}
          markerShape={isHidden ? 'square' : markerShape}
          lineStyle={isHidden ? 'none' : lineStyle}
          lineColor={lineColor}
          lineLength={props.lineLength}
          lineWidth={props.lineWidth != null ? props.lineWidth : defaultLineWidth}
          markerColor={isHidden ? 'transparent' : markerColor}
          borderColor={isHidden ? markerColor || lineColor : props.borderColor}
          setAbsolutePos={true}
        />
      )}
    </div>
  );
};
